module.exports = __webpack_public_path__ + "static/img/logo-HAWTHORN.56c4d62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-HAWTHORN.svg
// module id = bHb/
// module chunks = 1